export default __webpack_public_path__ + "static/media/team13.72c930b1.JPG";